<script setup lang="ts">
  import { MATRIX_HAS_GENERATED_RECORDS_MESSAGE } from '../../api/form-builder.api';
</script>

<template>
  <p
    role="status"
    data-testid="locked-revision-notice"
    class="mt-3 rounded-md border border-[var(--theme-secondary-ink)] bg-white-01 px-4 py-3 text-sm text-gray-07"
  >
    {{ MATRIX_HAS_GENERATED_RECORDS_MESSAGE }}
  </p>
</template>
